//Frontend/src/unicodex_ui/services/portalApi.js
import api from "./apiClient";

const portalApi = {
  async getMe() {
    const res = await api.get("/api/portal/me");
    return res.data;
  },

  async listProducts() {
    const res = await api.get("/api/portal/products");
    return res.data;
  },

  // Frontend/src/unicodex_ui/services/portalApi.js

  async listProductBarcodes(productId) {
    const res = await api.get(`/api/identity/products/${productId}/barcodes`);
    return res.data; // { ok, barcodes }
  },

  async addProductBarcode(productId, payload) {
    const res = await api.post(`/api/identity/products/${productId}/barcodes`, payload);
    return res.data; // { ok, barcode }
  },

  async generateProductBarcodeB2(productId, payload) {
    // payload: { variantCode: number, setPrimary: boolean }
    const res = await api.post(`/api/identity/products/${productId}/barcodes/generate`, payload);
    return res.data; // { ok, barcode }
  },

  async deleteProductBarcode(productId, barcodeId) {
    const res = await api.delete(`/api/identity/products/${productId}/barcodes/${barcodeId}`);
    return res.data;
  },

  async setPrimaryBarcode(productId, barcodeId) {
    const res = await api.patch(`/api/identity/products/${productId}/barcodes/${barcodeId}/primary`);
    return res.data; // { ok }
  },


  async createProduct(payload) {
    const res = await api.post("/api/portal/products", payload);
    return res.data;
  },

  async listBatches(params = {}) {
    const res = await api.get("/api/portal/batches", { params });
    return res.data;
  },

  async createBatch(payload) {
    const res = await api.post("/api/portal/batches", payload);
    return res.data;
  },

  async generateCodes(batchId, count) {
    const res = await api.post(`/api/portal/batches/${batchId}/generate-codes`, {
      count,
    });
    return res.data;
  },

  async listCodes(batchId, params = {}) {
    const res = await api.get(`/api/portal/batches/${batchId}/codes`, { params });
    return res.data;
  },
};

export default portalApi;
